
export const baseURL = process.env.REACT_APP_API_URL;
export const webBaseURL = process.env.REACT_APP_BASE_URL;
export const projectId = process.env.REACT_APP_WALLET_CONNECT_ID;
export const txLinkUrl = process.env.REACT_APP_TX_LINK_URL;

export const isMainNet = process.env.REACT_APP_IS_MAINNET;
export const ReciptBridgeEth = process.env.REACT_APP_RECEIPT_BRIDGE_ETH;
export const ReciptBridgeBsc= process.env.REACT_APP_RECEIPT_BRIDGE_BSC;
export const ReciptBridgePolygon = process.env.REACT_APP_RECEIPT_BRIDGE_POLYGON;
export const ReciptBridgeAvax= process.env.REACT_APP_RECEIPT_BRIDGE_AVAX;

